let notificationAudio = null;

export const playNotificationSound = () => {
  if (!notificationAudio) {
    notificationAudio = new Audio("/iusevolutione/assets/audio/notification3.mp3");
    notificationAudio.loop = true;
  }
  notificationAudio.play().catch((err) => {
    console.warn("Failed to play sound:", err);
  });
};

export const stopNotificationSound = () => {
  if (notificationAudio) {
    notificationAudio.pause();
    notificationAudio.currentTime = 0; // Reset to start
  }
};
